/**
 * @file Defines the {@link UI_DOM_CONFIG} constant
 * @author Joe Thompson <joe.thompson@1x2gaming.com>
 */

/**
 * Config for UI DOM structure.
 * @type {ui-dom-config[]}
 * @constant
 */
const UI_DOM_CONFIG = [

    {

        id: 'gameFramework',
        element:   'div',
        classList: []

    },
    
    {

        id: 'new_betConsoleMobile',
        element:   'div',
        classList: []

    },

    {

        id: 'buttonWrapper',
        element:   'div',
        classList: [],
        siblings:  [

            {

                id: 'leftWrapper',
                element:   'div',
                classList: []

            },
        
            {

                id: 'rightWrapper',
                element:   'div',
                classList: []

            },
        
            {

                id: 'arch',
                element:   'div',
                classList: []

            }

        ]

    }

]

export { UI_DOM_CONFIG }
